import React, {useEffect, useState} from 'react';
import {saveAs} from 'file-saver';
import * as XLSX from 'xlsx';

import Loader from '../../../assets/animations/Loader';
import Button from '../../../common/components/Button/Button';
import {getAttentionHistoryExportRows} from './attentionHistoryExcel.utils';

const AttentionHistoryExcelDownloadButton = ({
  getAllAttentionsToDownload,
  attentionsToDownload,
  attentionsToDownloadState,
  fileName,
  headers,
  topRow,
  openModal,
}) => {
  const [loading, setLoading] = useState(false);
  const [dataToDownload, setDataToDownload] = useState([]);
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    setDataToDownload(attentionsToDownload);
  }, [attentionsToDownload]);

  const downloadAttentions = async () => {
    if (!attentionsToDownloadState.loading) {
      setIsClicked(true);
      getAllAttentionsToDownload();
    }
  };

  useEffect(() => {
    try {
      if (!isClicked) {
        return;
      }

      const shouldShowModal = dataToDownload.length >= 2000;
      const slicedData = dataToDownload.slice(0, 2000); // <-- Only first 2000
      const transformedData = getAttentionHistoryExportRows(
        slicedData,
        headers[0],
      );

      if (shouldShowModal) {
        openModal(); // Show message but still download
      }

      if (slicedData.length > 0 && !attentionsToDownloadState.loading) {
        console.log(slicedData);

        const worksheet = XLSX.utils.json_to_sheet([], {skipHeader: true});

        let startRow = 0;

        if (topRow) {
          const maxLength = headers[0]?.length || 0;
          const paddedTopRow = [
            ...topRow,
            ...Array(Math.max(0, maxLength - topRow.length)).fill(''),
          ];
          XLSX.utils.sheet_add_aoa(worksheet, [paddedTopRow], {origin: 'A1'});
          startRow = 1;
        }

        XLSX.utils.sheet_add_aoa(worksheet, headers, {
          origin: `A${startRow + 1}`,
        });
        XLSX.utils.sheet_add_json(worksheet, transformedData, {
          origin: `A${startRow + 2}`,
          skipHeader: true,
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });
        const blob = new Blob([excelBuffer], {
          type: 'application/octet-stream',
        });
        saveAs(blob, `${fileName}.xlsx`);

        setIsClicked(false);
      }
    } catch (error) {
      console.error('Failed to export data:', error);
    } finally {
      setLoading(false);
    }
  }, [dataToDownload]);

  return !attentionsToDownloadState.loading ? (
    <Button onClick={downloadAttentions} disabled={loading} size="small">
      Descargar
    </Button>
  ) : (
    <Button disabled={true} size={'small'}>
      <Loader color={'#fff'} width={'14px'} height={'14px'} />
    </Button>
  );
};

export default AttentionHistoryExcelDownloadButton;
